const isEmpty = (elem) => {
  if (elem === null || elem === undefined) {
    return true;
  }
  return false;
};

module.exports = isEmpty;
